<ng-container *ngIf="loading">
  <div class="flex align-middle justify-center h-48 align-center m-auto">
    <adc-loading label-text="Loading..." class="adc-loading" lock-page-scrolling="true" state="active"></adc-loading>
  </div>
</ng-container>